// HTTP client for making API requests
import axios from "axios";
// Importing Hooks for managing component lifecycle and state
import { useState } from "react";
// Importing Material-UI components
import {
  Box,
  Button,
  Typography,
  Dialog,
  Grid,
  Container,
  CssBaseline,
} from "@mui/material";
// Importing custom hooks
import {
  authErrorRedirect,
  apiURI,
  useAuthInfo,
  LoadingButtonText,
} from "../../../common";

// Component for Head of Department (HOD) Approval Modal
export function HODApprovalModal(props) {
  // State to manage form errors
  const [errors, setErrors] = useState();
  // Custom hook to get decoded authentication information
  const decoded = useAuthInfo();
  // State to track form submission status
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Function to close  modal
  const handleClose = () => {
    props.setOpen(false);
  };
  // Handle approval or rejection of bulk samples
  const handleApproval = ({ e, approval }) => {
    e.preventDefault();
    setErrors();
    setIsSubmitting(true);
    // Determine comments based on HOD role and approval status
    let comments;
    if (decoded.role === "hod") {
      if (approval === true) {
        comments = "Approved in bulk";
      }
      if (approval === false) {
        comments = "Rejected in bulk";
      }
    }

    // Prepare data object for API call
    const approvalObject = {
      approval,
      role: decoded.role,
      email: decoded.email,
      comments: comments,
      organization: decoded.organization,
      sampleRequestID: props.detailsData.sampleRequestID,
      selectedRowsData: props.selectedRowsData,
      itemList: props.itemList,
      requesterEmail: props.detailsData.email,
    };

    // API call to submit approval/rejection
    approvalObject &&
      axios
        .post(`${apiURI}/form/bulkApproveSupplier`, approvalObject)
        .then(() => {
          // Reset submitting state after successful submission
          setIsSubmitting(false);
          // Refresh the page to reflect changes
          window.location.reload(true);
        })
        .catch((response) => {
          console.log("error in axios login call react");
          setErrors({});
          setErrors(response.response.data);
          // Redirects to error page if authentication error occurs
          authErrorRedirect(response.response.data, props.history);
        });

    // eslint-disable-next-line no-console
  };

  errors && console.log(errors);

  // Render the HOD Approval Modal component
  return (
    <div>
      <Dialog open={props.open} onClose={handleClose} {...DialogProps}>
        <Box {...MainBoxProps}>
          <Container {...ContainerProps}>
            {/* Render Modal title */}
            <Typography component="h1" variant="h5">
              HOD Approval
            </Typography>
            <Typography {...TypographyProps}>
              Bulk approve or reject all the samples received.
            </Typography>
            <Typography {...TypographyProps}>
              <b> Note: </b>This will Approve/Reject all samples pending action
              for this item.
            </Typography>
            <CssBaseline />
            {/* Render Approve/Reject Buttons */}
            <Box {...FormBoxProps}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Grid {...ButtonGridProps}>
                    {/* Button for Approve action */}
                    <Grid item xs={6}>
                      <Button
                        variant="contained"
                        onClick={(e) =>
                          handleApproval({
                            e,
                            approval: true,
                          })
                        }
                        fullWidth
                        color="success"
                        disabled={isSubmitting}
                      >
                        <LoadingButtonText
                          loading={isSubmitting}
                          text="Approve"
                        />
                      </Button>
                    </Grid>
                    {/* Button for Reject action */}
                    <Grid item xs={6}>
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={(e) =>
                          handleApproval({
                            e,
                            approval: false,
                          })
                        }
                        color="error"
                        disabled={isSubmitting}
                      >
                        <LoadingButtonText
                          loading={isSubmitting}
                          text="Reject"
                        />
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </Dialog>
    </div>
  );
}

const DialogProps = {
  style: {
    height: "90%",
  },
  PaperProps: { sx: { borderRadius: "20px" } },
};
const MainBoxProps = {
  sx: {
    flexDirection: "column",
    alignItems: "center",
  },
};
const ContainerProps = {
  component: "main",
  maxWidth: "sm",
  sx: {
    marginTop: 4,
    flexDirection: "column",
    alignItems: "center",
  },
};
const TypographyProps = {
  sx: {
    mt: 2,
  },
};
const FormBoxProps = {
  component: "form",
  noValidate: true,
  sx: {
    mt: 3,
  },
};
const ButtonGridProps = {
  container: true,
  item: true,
  xs: 12,
  direction: "row",
  sx: {
    mt: 3,
    mb: 3,
  },
  columnSpacing: 6,
};
